var _ellipse, _path, _path2, _path3, _path4, _circle, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataMapper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 4.5,
    rx: 3.5,
    ry: 1.5,
    stroke: "white",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 11C11 12.1046 9.433 13 7.5 13C5.567 13 4 12.1046 4 11",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 7.5C11 8.60457 9.433 9.5 7.5 9.5C5.567 9.5 4 8.60457 4 7.5",
    stroke: "white",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 11V5M4 11V5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 13.8571C21.25 14.5702 20.8152 15.5042 20.1309 16.485C19.4689 17.434 18.6639 18.3009 18.1128 18.8533C18.0764 18.8898 18.0364 18.903 18 18.903C17.9636 18.903 17.9236 18.8898 17.8872 18.8533C17.3361 18.3009 16.5311 17.434 15.8691 16.485C15.1848 15.5042 14.75 14.5702 14.75 13.8571C14.75 12.1666 16.1791 10.75 18 10.75C19.8209 10.75 21.25 12.1666 21.25 13.8571Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 14,
    r: 0.5,
    fill: "white",
    stroke: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.54172 13C4.49993 13.5 2.48796 16.2291 3.49992 18C5.50001 21.5 8 16.5 11 17.5C13.1213 18.2071 12.5 20.5 15 20.5C17 20.5 17.6667 19.3333 18 19",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataMapper);
export default __webpack_public_path__ + "static/media/Data Mapper.bf65675e2a619e6cf86657c45b11ddb4.svg";
export { ForwardRef as ReactComponent };